import { sidebarKeys } from '~/components/sidebar/utils/navigation-utils';
import { create } from '~/utils/store/createStore';

export const SIDEBAR_CLOSED_WIDTH = '34px';
export const SIDEBAR_EXPANDED_WIDTH = '100px';

export type LsegPlatform = 'ws' | 'teams';

export interface AppStore {
  isSidebarExpanded: boolean;
  sidebarExpandConfig: Record<string, boolean>;
  setSidebarExpanded: (value: boolean) => void;
  setSidebarExpandConfig: (value: Record<string, boolean>) => void;
  lsegPlatform?: LsegPlatform;
  initialiseLsegEnv: () => void;
}

const LSEG_PLATFORM_KEY = 'platform';

export const useApp = create<AppStore>(set => ({
  isSidebarExpanded: true,
  lsegPlatform: undefined,
  initialiseLsegEnv: () => {
    const params = new URLSearchParams(window.location.search);
    const url = new URL(window.location.href);
    const platform = params.get(LSEG_PLATFORM_KEY);

    if (platform === 'ws' || platform === 'teams') {
      set({ lsegPlatform: platform });
    }

    url.searchParams.delete(LSEG_PLATFORM_KEY);
    window.history.replaceState(null, '', url);
  },
  sidebarExpandConfig: {
    [sidebarKeys.settings]: true,
    [sidebarKeys.screener]: true,
    [sidebarKeys.watchlist]: true,
    [sidebarKeys.quickAnalysis]: false,
    [sidebarKeys.document]: false,
    [sidebarKeys.stream]: true,
  },
  setSidebarExpanded: (value: boolean) => set({ isSidebarExpanded: value }),
  setSidebarExpandConfig: (value: Record<string, boolean>) =>
    set({ sidebarExpandConfig: value }),
}));
